export default "__VITE_ASSET__b670a1d5__"